// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tabs[data-v-0df9b3ab] {\n  height: calc(100vh - 140px);\n}\n.footer[data-v-0df9b3ab] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  /* margin-top: 20px; */\n  padding: 10px 20px;\n}\n", ""]);
// Exports
module.exports = exports;
